import { takeLatest, put } from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionSetGridDataInvalid,
  actionSetGridDataValid,
} from 'react-redux-app/lib/modules/grid/actions';

import { getSiteTextsGridName } from '../../utils/siteTextsGrid';

import {
  ACTION_EDIT_SITE_TEXTS__REQUEST,
  ACTION_EDIT_SITE_TEXTS__SUCCESS,
  ACTION_EDIT_SITE_TEXTS__FAIL,

  ACTION_DELETE_SITE_TEXTS__REQUEST,
  ACTION_DELETE_SITE_TEXTS__SUCCESS,
  ACTION_DELETE_SITE_TEXTS__FAIL,
} from '../../actionTypes';


function* enableGrid(action) {
  try {
    const { langKey } = action.payload;

    yield put(actionSetGridDataValid(getSiteTextsGridName(langKey)));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

function* disableGrid(action) {
  try {
    const { langKey } = action.payload;

    yield put(actionSetGridDataInvalid(getSiteTextsGridName(langKey)));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga() {
  yield takeLatest([
    ACTION_EDIT_SITE_TEXTS__REQUEST,
    ACTION_DELETE_SITE_TEXTS__REQUEST,
  ], disableGrid);

  yield takeLatest([
    ACTION_EDIT_SITE_TEXTS__SUCCESS,
    ACTION_EDIT_SITE_TEXTS__FAIL,
    ACTION_DELETE_SITE_TEXTS__SUCCESS,
    ACTION_DELETE_SITE_TEXTS__FAIL,
  ], enableGrid);
}
